import { useEffect, useState } from 'react';
import './App.css';
import './css/loader.css';
import Header from './components/page/Header';
import Body from './components/page/Body';
import Footer from './components/page/Footer';
import { getCookie, clearQueryParams, getExpireDate, updateUserLastAction, removeCurrentUserSession, deleteCookie, getAppUser} from './functions/utils'; // Import the utility function
import { TranslationProvider } from './components/utilities/TranslationContext';

function App() {
  const [authReady, setAuthReady] = useState(false);

  useEffect(() =>{
    
    //Check query params to handle factview authentication
    const queryParams = new URLSearchParams(window.location.search);
  
    if(queryParams.get("auth_code") && queryParams.get("client_id")){
      fetch('https://api2.factview.nl/tokens/exchange_authcode?auth_code='+queryParams.get("auth_code")+"&client_id="+queryParams.get("client_id")+"&user_id="+queryParams.get("user_id"))
      .then(
        response => { return response.json()})
      .then(data => {
        const accessExpiration = getExpireDate(10);
        const refreshExpiration = getExpireDate(60 * 24 * 30);
        document.cookie = `factview_access=${data["accessToken"]};expires=`+accessExpiration+`;path=/`;
        document.cookie = `factview_refresh=${data["refreshToken"]};expires=`+refreshExpiration+`;path=/`;
        clearQueryParams(["auth_code", "client_id", "user_id"]);
        setAuthReady(true);
      })
      .catch(error => {
        console.error('Error fetching token data:', error);
        setAuthReady(true);
      });
    }
    else{
      createSession();
    }
  }, []); // [] makes sure that this useEffect block only runs on the first render of the component

  async function createSession(){
    try{
      const queryParams = new URLSearchParams(window.location.search);
      if(queryParams.get("logout")){
        clearQueryParams(["logout"]);
        await removeCurrentUserSession();
        await deleteCookie("factview_access");
        await deleteCookie("factview_refresh");
        await deleteCookie("session_id");
        var response = await fetch('/session/create');
        var responseData = await response.json();
        document.cookie = `session_id=${responseData["session_id"]}; path=/`
        var param_ai = "";
        var clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW;
        if(queryParams.get("import_ai")){
          clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW_AI;
          param_ai = "&import_ai=" + queryParams.get("import_ai");
        }
        if(queryParams.get("fvai")){
          param_ai += "&fvai=" + queryParams.get("fvai");
        }
        window.location.href = `https://monitor.factview.nl/oauth/index.php?logout=1&client_id=${clientId}&import_session=${responseData["session_id"]}${param_ai}`;
      }

      if(queryParams.get("import_ai") || queryParams.get("fvai")){
        await deleteCookie("factview_access");
        await deleteCookie("factview_refresh");
        await deleteCookie("session_id");
      }

      var response = await fetch('/session/create');
      var responseData = await response.json();
      document.cookie = `session_id=${responseData["session_id"]}; path=/`;

      await factview_auth();
    }
    catch(error) {
      console.error('Error fetching session data:', error);
      setAuthReady(true);
    }

  }
  async function factview_auth() {
    const queryParams = new URLSearchParams(window.location.search);
    updateUserLastAction();
    // Perform the factview authentication process
    var clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW;
    var param_ai = "";

    if(queryParams.get("import_ai")){
      param_ai = "&import_ai="+queryParams.get("import_ai");
      clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW_AI;
    }
    if(queryParams.get("fvai")){
      param_ai += "&fvai="+queryParams.get("fvai");
    }
    try{  
      fetch('https://api2.factview.nl/access_token', {
        headers: {
          Authorization: 'Bearer '+getCookie('factview_access'),
          // 'Content-Type': 'application/json',
        },
      }).then(response => {
        if (!response.ok) {
          if (response.status === 401 || response.status === 404) {
            // Handle token expiration or invalid token
            // Perform token refresh
            fetch('https://api2.factview.nl/refresh_token', {
              headers: {
                Authorization: 'Bearer '+getCookie('factview_refresh'),
              },
            })
            .then(response => {
              if (!response.ok) {
                if (response.status === 401|| response.status === 404) {
                  // Handle token expiration or invalid token
                  // Perform re-authentication — page will navigate away
                  if(param_ai == "69ccf0286c1679f6b9808fd2" || param_ai == "69b3da251ec44f515c0bb0a3"){
                    alert('https://monitor.factview.nl/oauth/index.php?client_id='+clientId+'&import_session='+getCookie('session_id')+param_ai);
                  }
                  window.location.href = 'https://monitor.factview.nl/oauth/index.php?client_id='+clientId+'&import_session='+getCookie('session_id')+param_ai;
                } else {
                  // Handle other authorization errors
                  setAuthReady(true);
                }
              } else {
                // Process the successful response
                return response.json();
              }
            }).then(responseData => {
                if(!responseData) return;
                fetch('https://api2.factview.nl/tokens/refresh_access?refresh_token='+responseData["refresh_token"]).then(refreshResponse => {
                  if(refreshResponse.ok){
                    return refreshResponse.json();
                  }
                }).then(refreshData => {
                  updateSessionUserId(refreshData["user_id"]);

                  const accessExpiration = getExpireDate(10);
                  document.cookie = `factview_access=${refreshData["accessToken"]};expires=`+accessExpiration+`;path=/`;
                  setAuthReady(true);
                });
            })
            .catch(() => {
              setAuthReady(true);
            });
          } else {
            // Handle other authorization errors
            setAuthReady(true);
          }
        }
        else {
          // Process the successful response
          return response.json();
        }
      }).then(responseData =>{
        if(responseData){
          updateSessionUserId(responseData["user_id"]);
          setAuthReady(true);
        }
      }).catch(() => {
        setAuthReady(true);
      });
    }
    catch{
      setTimeout(function(){
        return factview_auth();
      }, 500);
    }
  }

  function updateSessionUserId(user_id){
    if(getCookie('session_id')){
      fetch('/import_session/update_user_id', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: getCookie('session_id'),
          user_id: user_id,
        }),
      }).then(refreshResponse => {
        if(refreshResponse.ok){
          return refreshResponse.json();
        }
      }).then(refreshData => {

      return refreshData;
      });
    }
    else{
    }
  }

  return (
    <div className="App">
      <TranslationProvider>
        {<Header />}
        {authReady
          ? <Body />
          : <div className="body-loader"><div className="loader"></div></div>
        }
        {<Footer />}
      </TranslationProvider>
    </div>
  );
}

export default App;
